import { Result } from 'domain/types';
import CreateWidgetClient from 'use-case/widgets/create/createWidgetClient';
import CreateWidgetCriteria from 'use-case/widgets/create/createWidgetCriteria';
import BasicEntity from 'domain/entity/basicEntity';

export type CreateWidgetResult = Result<BasicEntity>;
export type CreateWidget = (criteria: CreateWidgetCriteria) => Promise<CreateWidgetResult>;

export default (createWidgetClient: CreateWidgetClient): CreateWidget => (criteria: CreateWidgetCriteria): Promise<CreateWidgetResult> =>
    createWidgetClient(criteria);
